import { useNavigate } from 'react-router-dom';
import '../CSS/Global.css';
import { stripHtml } from '../utils/stringUtils';
import Fruits from '../Images/fruits-main.webp'
import { useGlobalContext } from './Context/GlobalContext';
import siteLogo from "../Images/160X60-BIGBULL-PAISEWALA.png";


const BigBullWorldCards = ({ key, store, ratingsSummary }) => {

    // console.log(store);
    const { fetchCartData, cart, totalCartItem } = useGlobalContext();
    const navigate = useNavigate()
    const url = process.env.REACT_APP_URL || 'https://filmlocation.100billion.in'

    const resolveListingImageSrc = (imgPath) => {
        if (!imgPath) return siteLogo;
        if (imgPath.startsWith("http")) return imgPath;
        return `${url}/${imgPath}`;
    };

    const handleListingImageError = (e) => {
        const target = e.currentTarget;
        if (!target || target.dataset?.fallbackApplied === "true") return;
        if (target.dataset) target.dataset.fallbackApplied = "true";
        target.src = siteLogo;
        target.style.opacity = "0.5";
    };
    const truncateStoreName = (name) =>
        name.length > 20 ? name.slice(0, 20) + '...' : name;


    return (
        <>
            {/* <div key={key} className="bigbullcard-list2"> */}
            <div className="bigbull-card">
                <div className="card-body">
                    <div className="card-body-img" onClick={() => navigate(`/detail-listing/${store.id}/${store.businessDetails.businessName}`)}>
                        <img
                            src={
                                resolveListingImageSrc(store.formImages?.[0])
                            }
                            alt={store.businessDetails?.businessName || "Store image"}
                            onError={handleListingImageError}
                        />
                    </div>
                    <p className="store-name" onClick={() => navigate(`/detail-listing/${store.id}/${store.businessDetails.businessName}`)}>
                        {truncateStoreName(store.businessDetails.businessName)}
                    </p>
                    <p className="store-category" onClick={() => navigate(`/detail-listing/${store.id}/${store.businessDetails.businessName}`)}>
                        {(store.subcategory && String(store.subcategory).trim()) || store.category || '—'}
                    </p>
                    <p className="store-description" onClick={() => navigate(`/detail-listing/${store.id}/${store.businessDetails.businessName}`)}>
                        {(stripHtml(store.businessDetails?.description || '') || '—').slice(0, 50)}
                        {(stripHtml(store.businessDetails?.description || '')?.length || 0) > 50 ? '...' : ''}
                    </p>
                    <p className="store-timing" onClick={() => navigate(`/detail-listing/${store.id}/${store.businessDetails.businessName}`)}>
                        {store.businessTiming?.timeSlots?.[0]
                            ? `${store.businessTiming.timeSlots[0].day || ''}: ${store.businessTiming.timeSlots[0].openTime || '—'} - ${store.businessTiming.timeSlots[0].closeTime || '—'}`
                            : '—'}
                    </p>
                    <p className="rating" onClick={() => navigate(`/detail-listing/${store.id}/${store.businessDetails.businessName}`)}>
                        <span className='rating-average'>{ratingsSummary[store.user_id]?.average || 0}{' '}</span>
                        <i className="fa-solid fa-star"></i>{' '}
                        <span className='no-of-ratings'>{ratingsSummary[store.user_id]?.count || 0} Ratings</span>
                    </p>
                </div>
            </div>

            {/* </div> */}
        </>
    );
};

export default BigBullWorldCards;